import {CheckCircleFillIcon} from '@primer/octicons-react'

import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function RebasedIcon({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Rebased) return null

  return <CheckCircleFillIcon size={12} className="color-fg-success" />
}
